// Array-first accessors for a project's active stages, falling back to the
// legacy single-value fields while both are served during rollout.

export function getCurrentStageIds(project) {
  if (
    Array.isArray(project?.currentStageIds) &&
    project.currentStageIds.length
  ) {
    return project.currentStageIds;
  }
  return project?.currentStageId ? [project.currentStageId] : [];
}

export function getCurrentStageNames(project) {
  if (
    Array.isArray(project?.currentStageNames) &&
    project.currentStageNames.length
  ) {
    return project.currentStageNames;
  }
  // Name-or-id fallback keeps the result pairwise-aligned with
  // getCurrentStageIds (same rule as the backend helper).
  return project?.currentStageId
    ? [project.currentStageName || project.currentStageId]
    : [];
}
